import { useEffect } from 'react';

import usePageData from '../api/hooks/usePageData';
import { MetaViewModel } from '../view-models/MetaViewModel';
import { useRouter } from './Router';

export function generateTitle(meta: MetaViewModel): string | undefined {
  if (!meta) return '';
  return meta.title
    ? meta.title !== meta.siteName && meta.siteName
      ? `${meta.title} | ${meta.siteName}`
      : meta.title
    : meta.siteName;
}

type Props = {
  value?: string | null;
  title?: string | null;
};

export function resolveDocumentTitle(
  meta: MetaViewModel | undefined,
  { value, title }: Props = {},
): string | undefined {
  if (title) return title;
  if (!meta) return undefined;

  const metaTitle = generateTitle(meta);
  return metaTitle
    ? value
      ? `${value} | ${metaTitle}`
      : metaTitle
    : undefined;
}

/**
 * Update the document title whenever the meta data changes
 */
function DocumentTitle({ value, title }: Props) {
  const { pathname } = useRouter();

  const { data } = usePageData(pathname);
  const meta = data?.meta;

  useEffect(() => {
    const resolvedTitle = resolveDocumentTitle(meta, { value, title });
    if (resolvedTitle) {
      document.title = resolvedTitle;
    }
  }, [meta, title, value]);
  return null;
}

export default DocumentTitle;
